import React from 'react';

import Hero from '../../components/Common/Hero/Hero';
import MetaData from '../../components/Common/MetaData/MetaData';
import ContactUs from '../../components/Common/ContactUs/ContactUs';

import DataAnalyticsHeroImage from '../../assets/images/heros/data-analysis-hero.png';
import DataBricksChart from '../../assets/images/databricks/databricks-charts.png';
import DataBricksScreen from '../../assets/images/databricks/databricks-screen.png';
import fedRamp from '../../assets/images/databricks/fed-ramp.jpg';
import dataBricks from '../../assets/images/databricks/databricks.jpg';
import dataBricksLogo from '../../assets/images/databricks/data-bricks-logo.jpg';

export default function Databricks() {
  return (
    <div className="Databricks">

      <MetaData
        title="Data Analytics Solutions for Actionable Intelligence"
        description="We stay ahead of cutting-edge data analytics methodologies to provide better outcomes
        for your big data. Get your free data solutions consultation today."
        image={DataAnalyticsHeroImage}
      />

      <Hero
        image={DataAnalyticsHeroImage}
        title="Databricks Consulting"
        detail="Harness the Power of Data with Our Databricks Partnership"
        reducedFont={true}
      />

      <div className="container">

        <p className="lead pt-5 pb-3">
          Databricks has transformed how organizations harness the power of data. Its
          unified platform brings together data engineering, analytics, and AI, all in a
          collaborative environment. As a trusted Databricks partner, BNL Consulting delivers
          tailored, cloud-native solutions that enable public and private sector clients to
          modernize their data infrastructure, reduce costs, and accelerate mission success.
        </p>

        <hr className="my-5"/>

        <div className="row">
          <div className="col-lg-6 col-sm-12 offset-lg-1 offset-sm-0 order-lg-last">

            <h2 className="h3">
              Why BNL Chooses Databricks
            </h2>

            <p>At BNL, Databricks is a cornerstone of
              our data strategy because it delivers
              what our clients need most: a secure,
              scalable platform, accelerated insights,
              and AI-ready infrastructure, all within a
              collaborative environment. For federal
              agencies, these strengths translate into
              stronger data governance, faster
              decision-making, and mission-aligned outcomes, all backed by a FedRAMP-ready
              foundation. </p>


            <h2 className="h5">
              What This Means for Our Clients
            </h2>
            <ul>
              <li><strong>Faster Time-to-Insight:</strong> Quickly turn raw data into actionable intelligence.</li>
              <li><strong>Secure Collaboration:</strong> Unite cross-functional teams within a compliant, controlled
                workspace.
              </li>
              <li><strong>Cloud-Native Cost Efficiency:</strong> Optimize infrastructure without sacrificing scalability
                or performance.
              </li>
              <li><strong>Future-Ready Architecture:</strong> Build a foundation for AI/ML, real-time analytics, and
                long-term modernization.
              </li>
            </ul>
          </div>

          <div className="col-lg-5 col-sm-12">

            <img
              className="responsive-image"
              alt="Data Bricks"
              src={dataBricksLogo}
            />

          </div>
        </div>

        <hr className="my-5"/>


        <div className="row">
          <div className="col-lg-5 col-sm-12 offset-lg-1 offset-sm-0 order-sm-last">
            <img
              className="responsive-image"
              alt="data scientist"
              src={dataBricks}
            />

          </div>

          <div className="col-lg-6 col-sm-12  order-lg-first ">
            <h3>Key Benefits of Our Databricks Solutions </h3>

            <h5>Accelerated Insights and Faster Time-to-Value </h5>
            <p>
              Accelerate the delivery of dashboards, reports, and predictive models. Databricks
              reduces development time, enabling federal teams to make data-informed
              decisions quickly and confidently.
            </p>
            <h5>Collaborative Analytics Across Teams </h5>
            <p>
              The Databricks Lakehouse Platform connects data engineers, analysts, scientists,
              and business users in one shared workspace. This unified approach breaks down
              silos and enables real-time collaboration, driving alignment, and innovation.
            </p>
            <h5>Cost Efficient, Cloud-Native Architecture </h5>
            <p>
              Databricks' cloud-native architecture,
              optimized for performance and elasticity,
              reduces infrastructure costs and
              simplifies data operations. Our clients
              benefit from reduced overhead and
              improved resource utilization, delivering measurable ROI.
            </p>

          </div>

        </div>

        <hr className="my-5"/>

        <div className="row">
          <div className="col-lg-6 col-sm-12 offset-lg-1 offset-sm-0 order-lg-last">
            <h5>Future-Ready Data Architecture </h5>
            <p>
              Databricks supports advanced analytics, real-time processing, and AI/ML
              capabilities, making it ideal for federal agencies preparing for long-term
              modernization and data-driven transformation.
            </p>
            <h5>Strategic Support from BNL Experts </h5>
            <p>
              As a certified Databricks partner, BNL Consulting provides full-lifecycle support,
              from implementation and migration to optimization, training, and long-term
              enablement. We work closely with your team to ensure your Databricks investment
              delivers lasting business value.
              For our federal clients, we bring specialized expertise in navigating compliance
              requirements and secure environments. Our solutions are aligned with government
              frameworks, including:
            </p>
            <ul>
              <li>FedRAMP Moderate and High baselines</li>
              <li>NIST 800-53 security controls</li>
              <li>Section 508 accessibility standards</li>
              <li>Risk Management Framework (RMF) lifecycle support</li>
            </ul>
            <p>
              With BNL, agencies can modernize confidently, knowing their data platforms meet
              mission demands and federal mandates.
            </p>

          </div>

          <div className="col-lg-5 col-sm-12">

            <img className="responsive-image"
                 alt="DataBricks Chart Screenshot"
                 src={DataBricksChart}/>

            <img className="responsive-image mt-5"
                 alt="DataBricks Screenshot"
                 src={DataBricksScreen}/>
          </div>
        </div>

        <hr className="my-5"/>

        <div className="row">
          <div className="col-lg-5 col-sm-12 offset-lg-1 offset-sm-0 order-sm-last">
            <img
              className="responsive-image"
              alt="FedRamp"
              src={fedRamp}
              width={"85%"}
            />
          </div>

          <div className="col-lg-6 col-sm-12  order-lg-first ">
            {/* --- */}
            <h5>
              Purpose-Built Visualizations for Public Impact
            </h5>
            <p>
              Our teams develop intuitive, impactful dashboards using Databricks integrated
              with platforms like Azure Synapse and Power BI. Whether tracking health metrics,
              financial trends, or operational performance, we help agencies:
            </p>
            <ul>
              <li>Visualize complex data clearly</li>
              <li>Enable self-service analytics</li>
              <li>Support informed decision-making at every level</li>
            </ul>
            {/* --- */}

            {/* --- */}
            <h5>
              Deployed in Secure Government Clouds
            </h5>
            <p>
              We configure and deploy Databricks within government-authorized cloud
              environments such as:
            </p>
            <ul>
              <li>Azure Government</li>
              <li>AWS GovCloud</li>
            </ul>
            <p>
              BNL handles full lifecycle support migration, DevOps, data integration, and user
              training while ensuring alignment with federal security and privacy mandates.
            </p>
            {/* --- */}

            {/* --- */}
            <h5>
              Integrated Services to Accelerate Your Mission
            </h5>
            <p>
              In addition to Databricks expertise, our team delivers:
            </p>
            <ul>
              <li>Azure IaaS & PaaS optimization</li>
              <li>CI/CD pipelines with Azure DevOps</li>
              <li>Data pipeline architecture (Delta Lake, ADF)</li>
              <li>AI/ML model deployment and tuning</li>
              <li>End-user training and enablement</li>
            </ul>
            {/* --- */}

          </div>

        </div>

        <hr className="my-5"/>

        <div className="row">
          <div className="col-lg-8 col-sm-12  offset-lg-2">
            <h3>
              Ready to Change the Data Game?
            </h3>
            <p>
              Your data is one of your most valuable assets. Let’s use it to its full potential.
              Whether you're modernizing legacy systems, adopting AI-powered analytics, or
              simply seeking better visibility, our Databricks solutions can help. </p>
            <p>
              <a href="http://bnlconsulting.com/contact">Contact us today</a> to learn how BNL Consulting can help you
              unlock the full
              power of Databricks.
            </p>
          </div>

        </div>

        <div className="p-5"/>

      </div>

      <ContactUs>
        Looking to turn your data into actionable intelligence?
      </ContactUs>

    </div>
  );
}
